// extracted by mini-css-extract-plugin
export default {"wrapper":"InventoryCounter_wrapper"};